exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(true);
// imports


// module
exports.push([module.id, ".bluebackground{background:#020a2e!important}", "", {"version":3,"sources":["/opt/atlassian/pipelines/agent/build/src/layouts/UnAuthLayout/src/layouts/UnAuthLayout/UnAuth.scss"],"names":[],"mappings":"AAAA,gBACI,4BAA8B,CACjC","file":"UnAuth.scss","sourcesContent":[".bluebackground {\n    background: #020a2e !important;\n}\n"],"sourceRoot":""}]);

// exports
